{"title":"Such a lovely name ! {{pet_name}} is a ...","cta":"Next","male":"Male","female":"Female"}